import { parseISO, isBefore } from 'date-fns';
import React from 'react';
import PropTypes from 'prop-types';

import { getEntityUrl } from '@culture/common-helpers/cultureUtils';

import CommonPropTypes from 'utils/propTypes/common';
import { getHorizontalFile } from 'utils/helpers/files';

import EntityCard from './EntityCard';

const getIsMoviesUrl = (rubrics, type) => {
	if (type === 'broadcast') {
		return false;
	}

	const catalogRubricsPaths = [
		'theaters/performances',
		'music/concerts',
		'cinema/movies',
		'lectures/movies'
	];
	const streamingRubricPath = 'live';

	let hasCatalog = false;
	let hasStreaming = false;

	const isPartlyContainList = (list, desiredValue) =>
		list.some((item) => desiredValue.includes(item));

	const isPartlyContainString = (string, desiredValue) =>
		string.includes(desiredValue);

	const checkСoincidences = (rubric) => {
		const path = rubric?.path;

		if (!hasCatalog) {
			hasCatalog = isPartlyContainList(catalogRubricsPaths, path);
		}

		if (!hasStreaming) {
			hasStreaming = isPartlyContainString(path, streamingRubricPath);
		}
		return hasCatalog && hasStreaming;
	};

	return !!rubrics?.some(checkСoincidences);
};

const BroadcastCard = ({ data, size, onClick, withInstitute, ...rest }) => {
	const { thumbnailFile, additionalThumbnailFile, rubrics, type } = data;
	const publishDate = parseISO(data.publishDate);
	const now = new Date();
	const live =
		data.toDate &&
		isBefore(publishDate, now) &&
		isBefore(now, parseISO(data.toDate));
	let place;
	let url;

	if (data.institute && withInstitute) {
		place = {
			title: data.institute.title,
			url:
				data.institute.status === 'published'
					? getEntityUrl('institutes', data.institute)
					: null
		};
	}

	if (!onClick) {
		const entityName = getIsMoviesUrl(rubrics, type) ? 'movies' : 'broadcast';

		url = getEntityUrl(entityName, data);
	}

	const image = getHorizontalFile(thumbnailFile, additionalThumbnailFile, {});

	return (
		<EntityCard
			_id={data._id}
			title={data.title}
			image={image}
			place={place}
			url={url}
			date={publishDate}
			labels={live ? ['В эфире'] : null}
			size={size}
			onClick={onClick}
			themePlace="hide"
			microdata={data.microdata}
			{...rest}
		/>
	);
};

BroadcastCard.propTypes = {
	data: CommonPropTypes.entity.isRequired,
	size: PropTypes.string,
	onClick: PropTypes.func,
	withInstitute: PropTypes.bool
};

BroadcastCard.defaultProps = {
	withInstitute: true
};

export default BroadcastCard;
